import { useMutation } from '@northladder/services';
import { IApiError } from '@northladder/utilities';

import { CUSTOMER_SERVICE_API } from '../customerServiceClient';
import { IExportDealsQueryOptions } from '../types';

/**
 * React Query hook for exporting deals data to Excel.
 */
export const EXPORT_DEALS_MUTATION_KEY = 'export-deals-query-key';

interface IExportDealsMutationProps {
  /**
   * Callback to be called when the export fails
   */
  onErrorCallback: (err: IApiError) => void;
  /**
   * Callback to be called when the export is successful
   */
  onSuccessCallback: (fileData: BlobPart) => void;
}

/**
 * React Query mutation hook for exporting deals data to Excel.
 */
export const useExportDealsMutation = ({
  onErrorCallback,
  onSuccessCallback,
}: IExportDealsMutationProps) => {
  const { isPending, isError, error, mutate } = useMutation({
    mutationKey: [EXPORT_DEALS_MUTATION_KEY],
    networkMode: 'always', // Even make calls when offline
    mutationFn: (queryParams: IExportDealsQueryOptions) =>
      CUSTOMER_SERVICE_API.exportDealsExcel(queryParams),
    onSuccess: onSuccessCallback,
    onError: onErrorCallback,
  });

  return {
    error,
    isError,
    isPending,
    mutate,
  };
};
